import gql from 'graphql-tag';

export const GET_SUBMISSION_DOCUMENTS = gql`
  query GetLenderSubmissionDocuments($creditSubId: ID, $VOId: ID) {
    creditSubmissionDocuments(creditSubId: $creditSubId, VOId: $VOId) {
      documentId
      vendorOpportunityId
      source
      createdBy
      docName
      docType
      createdByAccount
      docDescription
      createdDateTime
      documentCreditSubmission {
        creditSubmissionId
        lenderAccess
        dealerAccess
      }
    }
    lenderDecisionLetters(creditSubId: $creditSubId) {
      documentId
      vendorOpportunityId
      source
      createdBy
      docName
      docType
      docDescription
      createdDateTime
      createdByAccount
      documentCreditSubmission {
        creditSubmissionId
        lenderAccess
        dealerAccess
      }
    }
  }
`;
